import { Box, Container, Stack, Text } from '@mantine/core'

export default function SiteLegalFooter () {
  const year = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        padding: '40px 20px 48px',
        background: 'var(--gs-bg)',
        borderTop: '1px solid var(--gs-border)'
      }}
    >
      <Container size="sm">
        <Stack spacing="md" align="center">
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 12,
              fontWeight: 600,
              color: 'var(--gs-text)',
              textAlign: 'center',
              letterSpacing: 0.2
            }}
          >
            © {year} GunSlop. All rights reserved.
          </Text>
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 11,
              color: 'var(--gs-muted)',
              textAlign: 'center',
              lineHeight: 1.65,
              maxWidth: 520
            }}
          >
            The GunSlop website, branding, logos, and original platform materials are protected by copyright,
            trademark, and other intellectual property laws. Unauthorized copying, modification, or distribution
            is prohibited except as permitted in writing or by applicable law.
          </Text>
          <Text
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 11,
              color: 'var(--gs-muted)',
              textAlign: 'center',
              lineHeight: 1.65,
              maxWidth: 520
            }}
          >
            Content on this site is provided for general informational and community purposes only and does not
            constitute legal, regulatory, safety, or professional advice. Your use of the site and any
            information or materials is at your own risk. You are solely responsible for complying with all
            applicable federal, state, and local laws and for following safe practices.
          </Text>
        </Stack>
      </Container>
    </Box>
  )
}
